import './animation.js'


// When the document is fully loaded
document.addEventListener("DOMContentLoaded", function() {

    // Contact form script
    let group_tags = document.querySelectorAll('.wpforms-form .list-of-procedures select option[value="group-start"]');

    group_tags.forEach(function(e, i) {
        let label = e.textContent;
        let sibling = e.nextElementSibling;
        let optGroup = document.createElement('optgroup');
        optGroup.label = label;

        while(sibling && !sibling.matches('option[value="group-start"]')) {
            optGroup.appendChild(sibling);
            sibling = e.nextElementSibling;
        }

        e.parentNode.replaceChild(optGroup, e);
    });

    // Fix for empty Elementor columns which only have background image
    document.querySelectorAll('.elementor-element-populated').forEach(function(el) {

        let count = el.querySelectorAll('.elementor-widget-wrap > div').length;
        if (count < 2) {
            if (getComputedStyle(el).backgroundImage !== 'none') {
                el.querySelector('.elementor-spacer-inner').classList.add('dummy-spacer');
            }
        }
    });
});
